import Swal from 'sweetalert2'
window.Swal = Swal;

import flatpickr from "flatpickr";
window.flatpickr = flatpickr;

import moment from 'moment';
window.moment = moment;

import toastr from 'toastr';
window.toastr = toastr;

window.Pikaday = require("pikaday");
window.Pickr = require('@simonwep/pickr');
window.timepicker = require('jquery-timepicker/jquery.timepicker');

import select2 from "select2";
window.select2 = select2;

import Chart from 'chart.js/auto';

import "jquery-ui/ui/widgets/datepicker";

require('./bootstrap');
require('./vimeo');
require('./transalations');

require('bootstrap');
require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('datatables.net-fixedcolumns-bs4');
//require('datatables.net-fixedheader-bs4');

import './calendar';

window.dataTableDefaultConfig = {
    "dom": '<"row top"<"col-md-6"i><"col-md-6 text-left"f>>r<"table-responsive"t><"row bottom mt-4"<"col-md-6"l><"col-md-6"p>><"clear">',
    "autoWidth": false,
    "info": true,
    "stateSave": true,
    "pageLength": 10,
    "lengthMenu": [[5, 10, 25, 50/*, -1*/], [5, 10, 25, 50/*, "All"*/]],
    "language": {
        "url": "//cdn.datatables.net/plug-ins/1.10.12/i18n/Italian.json"
    }
};
window.dataTableHomeConfig = {
    "dom": 'r<"table-responsive"t><"row bottom m-3"<"col-md-6"f><"col-md-6"p>><"clear">',
    "autoWidth": false,
    "info": false,
    "pageLength": 10,
    "lengthMenu": [[5, 10, 25, 50/*, -1*/], [5, 10, 25, 50/*, "All"*/]],
    "language": {
        "url": "//cdn.datatables.net/plug-ins/1.10.12/i18n/Italian.json"
    },
    "processing": true,
    "serverSide": true,
    "searching": true,
    "fixedColumns": true,
};

$(function () {

    $(".course-chart").each(function(index) {

        let percentual = $(this).data('percentual');

        Chart.register({
            id: 'textInside',
            afterDatasetsDraw: function (chart, _) {
                const ctx = chart.ctx;
                const width = chart.width;
                const height = chart.height;
                const fontSize = 15;
                ctx.font = fontSize + 'px Inter';
                ctx.fillStyle = '#00afda';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                const text = chart.config.plugins.textInside.text;
                const textX = Math.round(width / 2);
                const textY = Math.round(height / 2)+5;
                ctx.fillText(text, textX, textY);
            }
        });

        new Chart(
            $(this).find('canvas')[0].getContext('2d'),
            {
                type: 'doughnut',
                data: {
                    datasets: [{
                        data: [percentual, 100-percentual],
                        backgroundColor: [
                            '#00afda',
                            'rgb(255, 255, 255)'
                        ]
                    }]
                },
                options: {
                    cutout: 35,
                    events: null,
                    borderWidth: 0,
                    rotation: 0,
                    responsive: true,
                    animation: false,
                    maintainAspectRatio: false,
                },
                plugins: {
                    textInside: {
                        text: percentual+"%",
                    }
                }
            }
        );

    });

    // prevent submit form by enter button
    jQuery('input:not(.enable-enter)').on('keydown', function(event){
        if (event.key === "Enter" || event.keyCode === 13) {
            event.preventDefault();
            return false;
        }
    });

    // change business area
    $('#course_business_area_id').on('change', function() {
        if( $( this ).find(":selected").data('path') !== undefined) {
            window.location.replace($( this ).find(":selected").data('path'));
        }
    });

    // change machinery
    $('#course_machinery_id').on('change', function() {
        if( $( this ).find(":selected").data('path') !== undefined) {
            window.location.replace($( this ).find(":selected").data('path'));
        }
    });

    // switcher
    $('body').on('change', '.switch-user-status input', function() {
        axios.post('/admin/users/status/'+$( this ).data('id')+'/'+$( this ).is(':checked'))
            .then( (response) => {
                if(response.data.state=='true') {
                    Swal.fire({
                        title: 'User enabled',
                        html: 'The user has been notified',
                        icon: 'success',
                    });
                }
                $('#proposal-table').DataTable().ajax.reload();
            })
            .catch(function (error) {
                if (error.response) {
                    Swal.fire({
                        title: 'Error '+error.response.status,
                        html: error.response.data.message,
                        icon: 'error',
                    });
                }
            });
    });

    // reset button on datatable filter
    $('.datatable-search-form').on('click', '.btn-reset', function() {
        $(this).parent().find('input').val('').trigger('keyup').trigger('change');
    });
    $('.datatable-search-form').on('click', '.btn-reset-all', function() {
        let form = $(this).closest('.datatable-search-form');
        form.find('input').val('').trigger('keyup').trigger('change');
        form.find('select').val('').change();
    });

    // confirm before delete
    $('body').on('click', '.remove.with-confirm', function(event) {
        event.preventDefault();
        let href = $(this).attr('href');
        Swal.fire({
            title: __('general.delete_confirm_message'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: __('general.confirm'),
            cancelButtonText: __('general.cancel'),
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                window.location = href;
            }
        });
    });

    if(typeof Livewire !== 'undefined') {
        // Livewire before callback
        Livewire.on('confirm', e => {
            Swal.fire({
                title: __('general.delete_confirm_message'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: __('general.confirm'),
                cancelButtonText: __('general.cancel'),
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    Livewire.find(e.component_id)[e.callback](...e.argv)
                }
            });
        });
    }

});
